import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGraduationCap } from '@/fontawesome';
import UserCourseProgressSection from '@/components/admin/academy/UserCourseProgressSection';
import type { User } from '@/models';

interface UserDetailPageTabAcademyProps {
  user: User;
}

export default function UserDetailPageTabAcademy({ user }: UserDetailPageTabAcademyProps) {
  return (
    <div className="space-y-8">
      {/* Course Progress */}
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md border border-gray-200 dark:border-gray-700 p-6">
        <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-6 flex items-center">
          <FontAwesomeIcon icon={faGraduationCap} className="w-6 h-6 mr-3" />
          Kurs-Fortschritte
        </h2>
        <UserCourseProgressSection userId={user.id} userName={`${user.firstName} ${user.lastName}`} />
      </div>
    </div>
  );
}
